(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ra-product-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
  function openSizeChart(event) {
    var trigger = event.target.closest('[data-ra-size-chart-shortcut]');
    if (!trigger) return;

    var tabs = document.querySelector('.ra-product-tabs');
    if (!tabs) return;

    var sizeItem = tabs.querySelector('[data-ra-product-tabs-size-chart]');

    if (!sizeItem) return;

    sizeItem.open = true;
    sizeItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', openSizeChart);
})();
  } catch(e) { console.error(e); }
})();

})();
